import React from 'react';
import DocumentTitle from 'react-document-title';
import Select from '../components/Select';
import ListingPreviewsGroup from '../components/ListingPreviewsGroup';
import PageHero from '../components/PageHero';
import PageHeroContentSection from '../components/PageHeroContentSection';
import ArrowSvg from '../components/ArrowSvg';
import AnimatedScrollLink from '../components/AnimatedScrollLink';
import WaitlistForm from '../components/WaitlistForm/WaitlistForm';
import classnames from 'classnames';
import './Availability.scss';
import zenscroll from 'zenscroll';
import { filterPrivateListings } from '../../server/util';
export default class AvailabilityPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Track where the form data is in the process of being submitted.
      // Can be: not-started, in-progress, success, or error.
      submissionStatus: 'not-started',

      // Whether the user previously tried to submit the form. That submit
      // may never have started though, if their data was invalid, so this
      // flag is independent of submission status above.
      hasAttemptedSubmit: false,
    };

    // The DOM node for the listings. Used to scroll to it.
    this.listingsNode = null;
    this.toggleForm = this.toggleForm.bind(this);
    this.onSuccessSubmit = this.onSuccessSubmit.bind(this);
  }

  onSuccessSubmit() {
    this.setState({ submissionStatus: 'success' });
    const element = document.getElementById('success');
    zenscroll.center(element);
  }

  toggleForm(close) {
    const element = document.getElementsByClassName('waitlist-container');
    close
      ? element[0].classList.add('hide')
      : element[0].classList.contains('hide')
      ? element[0].classList.remove('hide')
      : element[0].classList.add('hide');
  }

  render() {
    const listings = this.props.listings;
    const listingsLoading = listings === undefined;
    const listingsError = listings instanceof Error;
    const filteredListings = filterPrivateListings(listings);
    console.log('Filtered', filteredListings);

    // Code for pagination and (broken) logic for a move in date filter can be
    // found in the git history: https://github.com/hungryinc/ashland/blob/a61e0f85f9425db72635d94e828c1f7a1b9826b3/app/pages/Availability.js
    return (
      <DocumentTitle title={this.props.pageTitle}>
        <div className="content avail" id="main" role="main">
          <PageHero heading="The Availabilities">
            <PageHeroContentSection>
              <p>
                Every luxury studio, 1-bedroom, and 2-bedroom apartment has
                expansive ceiling-high windows that provide sweeping views of
                Brooklyn. White oak hardwood floors, Corian windowsills, and
                Caesarstone and stainless steel countertops complement Bosch
                kitchen appliances and Grohe bathroom fixtures.   Every unit
                includes built-in washer/dryer units, in-sink garbage disposals,
                keyless electronic apartment entry, and pre-installed solar
                shades.
              </p>
              <AnimatedScrollLink getDomNode={() => this.listingsNode}>
                View the Availabilities{' '}
                <ArrowSvg className="icon-arrow-sm-svg-down" />
              </AnimatedScrollLink>
            </PageHeroContentSection>
          </PageHero>
          <fieldset
            className="listings"
            id="ListingSection"
            ref={(it) => {
              this.listingsNode = it;
            }}
          >
            <legend>
              <p className="filter-title">Filter listings by:</p>
            </legend>
            <div className="select-box list">
              <Select
                options={[
                  {
                    id: '0',
                    attr: 'price',
                    direction: 'reverse',
                    label: 'Price: Highest to Lowest',
                  },
                  {
                    id: '1',
                    attr: 'price',
                    direction: 'normal',
                    label: 'Price: Lowest to Highest',
                  },
                ]}
                onSelect={(option) =>
                  this.props.updateListingOptions({
                    sort: { attr: option.attr, direction: option.direction },
                  })
                }
              />

              <Select
                options={this.props.filters}
                onSelect={(option) =>
                  this.props.updateListingOptions({
                    filters: { layout: option.id },
                  })
                }
              />

              {/* <div className="select">
                <p className="cal-error">{this.state.showtooearlyerror}</p>
                <button className="selected" onClick={() => this.toggleCal()}>Move In Date : {this.state.moveindate.toString()}</button>

                <div className="cal-box">
                  <div className={this.state.showCal}>
                    // The Calendar component here is no longer included in package.json
                    // If we re-enable this, use the DatePicker component instead.
                    <Calendar onSelect={(value) => this.updateList('moveindate', value)} />
                  </div>
                </div>
              </div> */}
            </div>

            {Array.isArray(filteredListings) && filteredListings.length > 0 ? (
              <ListingPreviewsGroup items={filteredListings} />
            ) : (
              this.state.submissionStatus === 'not-started' && (
                <div className="waitlist-container-2">
                  <div className="waitlist-text">
                    <div className="waitlist-main-text">
                      Join our Priority Waitlist and be the first to know about
                      upcoming availability
                    </div>
                    <div className="waitlist-price-text">
                      <strong>Studio</strong> - Starting at $3,495
                    </div>
                    <div className="waitlist-price-text">
                      <strong>1BR</strong> - Starting at $4,495
                    </div>
                    <div className="waitlist-price-text">
                      <strong>2BR</strong> - Starting at $6,495
                    </div>
                  </div>
                  <WaitlistForm
                    className={'waitlist-form'}
                    toggleForm={this.toggleForm}
                    onSuccessSubmit={this.onSuccessSubmit}
                  />
                </div>
              )
            )}

            {listingsLoading && (
              <div className="loading-or-error">
                <p>Loading...</p>
              </div>
            )}

            {listingsError && (
              <div className="loading-or-error">
                <p>
                  An error ocurrred loading the listings. Try refreshing the
                  page.
                </p>
              </div>
            )}
          </fieldset>
          {this.state.submissionStatus === 'success' && (
            <p role="alert" className="success" id="success">
              You have been successfully added to the 300 Ashland Waitlist! The
              Leasing Team will contact you as soon as we have availability that
              matches your criteria.
            </p>
          )}
          {Array.isArray(listings) &&
            listings.length > 0 &&
            this.state.submissionStatus === 'not-started' && (
              <div>
                <div className="waitlist-intro">
                  <div className="waitlist-title">
                    DON'T SEE A HOME THAT WORKS FOR YOU?
                  </div>
                  <button
                    role="button"
                    tabIndex="0"
                    className={classnames('button')}
                    onClick={() => {
                      const element =
                        document.getElementsByClassName('waitlist-container');
                      element[0].classList.contains('hide')
                        ? element[0].classList.remove('hide')
                        : element[0].classList.add('hide');
                    }}
                  >
                    JOIN PRIORITY WAITLIST
                  </button>
                </div>
                <div className="waitlist-container hide">
                  <div className="waitlist-text">
                    <div className="waitlist-main-text">
                      Join our Priority Waitlist and be the first to know about
                      upcoming availability
                    </div>
                    <div className="waitlist-price-text">
                      <strong>Studio</strong> - Starting at $3,495
                    </div>
                    <div className="waitlist-price-text">
                      <strong>1BR</strong> - Starting at $4,495
                    </div>
                    <div className="waitlist-price-text">
                      <strong>2BR</strong> - Starting at $6,495
                    </div>
                  </div>
                  <WaitlistForm
                    className={'waitlist-form'}
                    toggleForm={this.toggleForm}
                    onSuccessSubmit={this.onSuccessSubmit}
                  />
                </div>
              </div>
            )}
          <small style={{ marginBottom: '20px', fontSize: '14px' }}>
            Required Fees To Rent: <br />
            $20 Application Fee per applicant <br />
            1st Month’s Rent <br />
            1 Month Security Deposit <br />
            <br />
            All pricing and availability are subject to change at any time.{' '}
            <br />
            All Two Trees apartments are No Fee when rented directly from
            Landlord without the use of a broker unless otherwise specified.{' '}
            <br />
            Listings and advertisements on this site are for informational
            purposes only and do not create a relationship between a real estate
            licensee or broker and the landlord or managing agent. <br />
            Listings and ads may not be republished.
          </small>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Availability.js